import React, { Component } from 'react'
import classnames from 'classnames'

import { AppContext } from '../../App'

import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Typography from '@material-ui/core/Typography'
import Paper from '@material-ui/core/Paper'
import Checkbox from '@material-ui/core/Checkbox'
import Chip from '@material-ui/core/Chip'
import Button from '@material-ui/core/Button'
import EditIcon from '@material-ui/icons/Edit'
import SearchIcon from '@material-ui/icons/Search'
import CloseIcon from '@material-ui/icons/Close'
import IconButton from '@material-ui/core/IconButton'
import Card from '@material-ui/core/Card'
import CardHeader from '@material-ui/core/CardHeader'
import CardContent from '@material-ui/core/CardContent'
import TextField from '@material-ui/core/TextField'
import FormGroup from '@material-ui/core/FormGroup'
import Grid from '@material-ui/core/Grid'

import { Link } from 'react-router-dom'

import { getProductsUnavailabilities } from '../../services/api'
import { authenticated } from '../../services/auth'
import { filter } from '../../services/filter'

import Loader from '../../components-utils/Loader'

import './Unavailabilities.css'

class Unavailabilities extends Component {
  state = { filtering: true, searchText: '' }

  async componentDidMount() {
    try {
      const auth = authenticated()
      const products = await getProductsUnavailabilities(
        auth.currentMerchant.code
      )
      this.setState({
        products,
        filtered: products,
        merchantCode: auth.currentMerchant.code
      })
    } catch (error) {
      this.setState(
        { products: [] },
        this.props.snackbar(
          'Une erreur est survenue pendant la récupération des données. Merci de recharger la page',
          'error'
        )
      )
    }
  }
  selectProduct = id => () => {
    this.setState({ selected: this.state.selected === id ? undefined : id })
  }
  changeSearch = e => {
    this.setState({ searchText: e.target.value })
  }
  toggleSearch = () => {
    this.setState(
      state => ({ filtering: !state.filtering }),
      () => {
        if (this.state.filtering) {
          document.getElementById('sp-unavailabilities--searchinput').focus()
        }
      }
    )
  }
  research = e => {
    e.preventDefault()
    const { products, searchText } = this.state
    this.setState({ filtered: filter(products, searchText) })
  }
  renderLoader() {
    return <Loader loading={true} />
  }

  renderTable() {
    const { filtered, selected, filtering, searchText } = this.state
    const paperClasses = classnames('sp-unavailabilities--page', {
      'sp-unavailabilities--page__filtering': filtering
    })
    const cardClasses = classnames('sp-unavailabilities--card', {
      'sp-unavailabilities--card__filtering': filtering
    })
    const tableClasses = classnames('sp-unavailabilities--table', {
      'sp-unavailabilities--table__filtering': filtering
    })
    return [
      <Paper key="page" className={paperClasses}>
        <Card key="header" className={cardClasses}>
          <CardHeader
            action={
              <IconButton onClick={this.toggleSearch}>
                {filtering ? <CloseIcon /> : <SearchIcon />}
              </IconButton>
            }
            title="Indisponibilités produits"
          />
          <Typography
            variant="subtitle1"
            className="sp-unavailabilities--title"
          />
          {filtering && (
            <CardContent>
              <form onSubmit={this.research}>
                <FormGroup>
                  <Grid container spacing={8}>
                    <Grid item xs={12} sm={10}>
                      <TextField
                        id="sp-unavailabilities--searchinput"
                        label="Votre recherche"
                        placeholder="Que recherchez-vous ?"
                        fullWidth
                        onChange={this.changeSearch}
                        value={searchText}
                      />
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      sm={2}
                      className="sp-unavailabilities--searchbuttoncontainer"
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        onClick={this.research}
                        className="sp-unavailabilities--searchbutton"
                      >
                        Rechercher
                      </Button>
                    </Grid>
                  </Grid>
                </FormGroup>
              </form>
            </CardContent>
          )}
        </Card>

        <Table className={tableClasses}>
          <TableHead>
            <TableRow>
              <TableCell />
              <TableCell>Libellé</TableCell>
              <TableCell />
            </TableRow>
          </TableHead>
          <TableBody>
            {filtered.length > 0 ? (
              filtered.map(product => {
                const {
                  id,
                  value: { technicalLabel },
                  unavailabilities
                } = product
                return (
                  <TableRow
                    key={id}
                    className="sp-unavailabilities--unavailability"
                    onClick={this.selectProduct(id)}
                    role="checkbox"
                    aria-checked={selected === id}
                    selected={selected === id}
                  >
                    <TableCell
                      padding="checkbox"
                      className="sp-unavailabilities--checkboxcell"
                    >
                      <Checkbox
                        checked={selected === id}
                        value={`selected-${id}`}
                        color="primary"
                      />
                    </TableCell>
                    <TableCell>{technicalLabel}</TableCell>
                    <TableCell numeric>
                      {unavailabilities.map(u => (
                        <Chip
                          key={`unavailability-${u.id}`}
                          className="sp-unavailabilities--chip"
                          label={`du ${u.startDate} au ${u.stopDate}`}
                        />
                      ))}
                    </TableCell>
                  </TableRow>
                )
              })
            ) : (
              <TableRow>
                <TableCell colSpan="3">Aucun produit</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </Paper>,
      <Link
        key="action"
        to={selected !== undefined ? `/unavailabilities/${selected}` : ''}
      >
        <Button
          className="sp-unavailabilities--actionbutton"
          variant="fab"
          color="secondary"
          aria-label="add"
          disabled={selected === undefined}
        >
          <EditIcon />
        </Button>
      </Link>
    ]
  }

  render() {
    const { filtered } = this.state
    return filtered !== undefined ? this.renderTable() : this.renderLoader()
  }
}

const enhanced = WrappedComponent => props => {
  return (
    <AppContext.Consumer>
      {app => <WrappedComponent {...props} snackbar={app.snackbar.open} />}
    </AppContext.Consumer>
  )
}
export default enhanced(Unavailabilities)



// WEBPACK FOOTER //
// ./src/components/unavailabilities/Unavailabilities.js